/**
 * @file CarrierSyncIntervalSelect.tsx
 * @description Период автообновления кэша ПВЗ (phase19.12).
 *
 * Реестр периодов данными: новый вариант = запись в INTERVAL_OPTIONS,
 * без правок разметки. null = автообновление выключено.
 */

import { Label } from "../ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";

const INTERVAL_OPTIONS: Array<{ value: string; label: string; hours: number | null }> = [
  { value: "off", label: "выключено", hours: null },
  { value: "6", label: "каждые 6 часов", hours: 6 },
  { value: "12", label: "каждые 12 часов", hours: 12 },
  { value: "24", label: "раз в сутки", hours: 24 },
  { value: "168", label: "раз в неделю", hours: 168 },
];

/** base-ui рендерит сырое value — подписи отдаём картой. */
const INTERVAL_LABELS: Record<string, string> = Object.fromEntries(
  INTERVAL_OPTIONS.map((o) => [o.value, o.label]),
);

interface Props {
  value: number | null;
  onChange: (hours: number | null) => void;
  disabled?: boolean;
}

export function CarrierSyncIntervalSelect({ value, onChange, disabled }: Props) {
  return (
    <div className="flex flex-col gap-1.5">
      <Label
        htmlFor="pickupSyncInterval"
        className="text-xs font-semibold uppercase tracking-wide text-on-surface-variant"
      >
        Автообновление
      </Label>
      <Select
        value={value === null ? "off" : String(value)}
        disabled={disabled}
        onValueChange={(next) => {
          const found = INTERVAL_OPTIONS.find((o) => o.value === String(next ?? "off"));
          onChange(found?.hours ?? null);
        }}
      >
        <SelectTrigger
          id="pickupSyncInterval"
          className="sm:max-w-xs"
          aria-label="Период автообновления кэша ПВЗ"
        >
          <SelectValue labels={INTERVAL_LABELS} placeholder="выключено" />
        </SelectTrigger>
        <SelectContent>
          {INTERVAL_OPTIONS.map((o) => (
            <SelectItem key={o.value} value={o.value}>
              {o.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <p className="text-xs text-on-surface-variant">
        Область и период применяются после сохранения настроек.
      </p>
    </div>
  );
}
